/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Order_MinInputs */

const en_queue_order_min = /** @type {(inputs: Queue_Order_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must be >= 0`)
};

const de_queue_order_min = /** @type {(inputs: Queue_Order_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muss >= 0 sein`)
};

/**
* | output |
* | --- |
* | "Must be >= 0" |
*
* @param {Queue_Order_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const queue_order_min = /** @type {((inputs?: Queue_Order_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Order_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_order_min(inputs)
	return de_queue_order_min(inputs)
});